module.exports = __webpack_public_path__ + "img/pic_YunlinCounty.a5c35ef4.jpg";